export default "__VITE_ASSET__CUy1AlcH__"